import {Accordion, AccordionDetails, AccordionSummary, Box, Typography, useMediaQuery} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useTheme} from '@mui/material/styles';
import {memo} from 'react';

const BaseWidget = ({errs, widgetName, ...props}) => {
  const theme = useTheme()
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Accordion
      defaultExpanded={mdUp}
      disableGutters={true}
      variant={errs ? 'error' : 'primary'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{color: errs ? '#A21C27' : '#FEFEFF'}}/>}
      >
        <Typography
          fontSize={14}
          color={errs ? 'error' : 'text.light'}>
          {widgetName}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{
        padding: '2px'
      }}>
        <Box sx={{
          border: '1px solid #c5c5c5',
          p: 1,
          borderRadius: '8px',
          bgcolor: theme.palette.base.rothko5,
        }}>
          <Box textAlign={'center'} sx={{ width: '100%' }}>
            {props.children.props.errs &&
              Object.values(props.children.props.errs).map((error, index) => (
                <Typography
                  key={index}
                  variant='caption'
                  color='error'
                  fontSize={'x-small'}
                  sx={{ display: 'block' }}
                >
                  {error}
                </Typography>
              ))}
          </Box>
          {props.children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default memo(BaseWidget);